<template>
  <div class="flex items-center space-x-4 m-4 select-none">
    <img
      :src= this.appLogo
      class="h-12 w-auto"
      alt="AllRead Logo"/>
    <div class="absolute top-10 right-16 flex gap-2 items-center" v-if="isSignedIn">
      <UserMenu @accountInfoFromUserMenu="accountInfoReceived" />
      <a class="flex text-sm hover:text-gray-600 rounded-xl z-20
        bg-white hover:bg-sky-200 border border-gray-300 hover:border-white
        transition-colors duration-300 text-center my-1 w-fit py-2 px-2 justify-center"
        target="_blank"
        href="https://allread.atlassian.net/servicedesk/customer/portals"
        :title="this.$t('userMenu.supportTitle')">
        <img :src="getIcon('supportIcon')"
          class="w-5 h-5"
          :title="this.$t('userMenu.supportTitle')"
          alt="support icon"/>
      </a>
    </div>
  </div>
  <TabSelector />
  <transition name="fade">
    <div id="pagetop" class="fixed right-10 bottom-6 bg-gray-100 rounded-full opacity-50 hover:opacity-70"
    v-show="scY > 300" @click="this.toTop(false)">
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
      stroke="#0ea5e9"
      stroke-width="1" stroke-linecap="square" stroke-linejoin="arcs">
      <path d="M18 15l-6-6-6 6"/>
    </svg>
    </div>
  </transition>
</template>

<script>
import useTransitStore from '@/stores/TransitStore';
import userManagementStore from '@/stores/UserManagementStore';
import TabSelector from '@/components/TabSelector.vue';
import UserMenu from '@/components/UserMenu.vue';
import { thereIsClientLogo } from '@/../TransitViewerConfig';
import { getIcon } from '@/utils/icons';

export default {
  name: 'TransitView',
  setup() {
    const transitStore = useTransitStore();

    return {
      transitStore,
      getIcon,
    };
  },
  data() {
    return {
      scY: 0,
      appLogo: getIcon('applicationLogo'),
    };
  },
  methods: {
    handleScroll() {
      this.scY = window.scrollY;
    },
    toTop(isIstantJump = false) {
      const jumpBehavior = isIstantJump ? 'instant' : 'smooth';
      window.scrollTo({
        top: 0,
        behavior: jumpBehavior,
      });
    },
    accountInfoReceived() {
      this.$router.push({ path: '/user' });
    },
    signedOut() {
      userManagementStore().signOut();
      this.$router.push({ path: '/login' });
    },
  },
  components: {
    TabSelector,
    UserMenu,
  },
  created() {
    document.title = this.$t('transitView.documentTitle');
  },
  async mounted() {
    if (thereIsClientLogo()) {
      const clientLogo = await this.transitStore.fetchClientLogo();
      if (clientLogo) {
        this.appLogo = clientLogo;
      }
    }
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('user-token-expired', this.signedOut);
    this.emitter.on('back-on-top', (isIstantJump) => this.toTop(isIstantJump));
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('user-token-expired', this.signedOut);
  },
  computed: {
    isSignedIn() {
      return userManagementStore().isSignedIn();
    },
  },
};
</script>
